/**
 * Design tokens for landing-page theme
 * Extracted from: https://rentnow.liveatzinnia.com/
 */

import type { DesignTokens } from '@vibesites/tokens';
import { defaultTokens } from '@vibesites/tokens';

export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    // Primary brand color - dark teal from the site
    primary: '#003c41',
    // Secondary brand color - lighter teal
    secondary: '#358083',
    // Accent - olive/khaki color used for highlights
    accent: '#4e5439',
    // Background colors
    background: '#ffffff',
    surface: '#f5f5f5',
    // Text colors
    text: '#1a1a1a',
    textMuted: '#6b7280',
    textOnPrimary: '#ffffff',
    textOnSecondary: '#ffffff',
    // Utility colors
    border: '#e5e7eb',
    error: '#dc2626',
    success: '#16a34a',
    warning: '#f59e0b',
  },
  font: {
    ...defaultTokens.font,
    // Inter family used throughout the site
    heading: '"Inter", "Poppins", system-ui, sans-serif',
    body: '"Inter", system-ui, sans-serif',
    accent: '"Poppins", sans-serif',
    mono: '"Fira Code", "Consolas", monospace',
  },
  fontSize: {
    ...defaultTokens.fontSize,
    xs: '0.75rem',      // 12px
    sm: '0.875rem',     // 14px
    base: '1rem',       // 16px
    lg: '1.125rem',     // 18px
    xl: '1.25rem',      // 20px
    '2xl': '1.5rem',    // 24px
    '3xl': '1.875rem',  // 30px
    '4xl': '2.25rem',   // 36px
    '5xl': '2.5rem',    // 40px
    '6xl': '3.125rem',  // 50px
  },
  fontWeight: {
    ...defaultTokens.fontWeight,
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
  spacing: {
    ...defaultTokens.spacing,
    xs: '0.25rem',      // 4px
    sm: '0.5rem',       // 8px
    md: '1rem',         // 16px
    lg: '1.5rem',       // 24px
    xl: '2rem',         // 32px
    '2xl': '3rem',      // 48px
    '3xl': '4rem',      // 64px
    '4xl': '6rem',      // 96px
  },
  radius: {
    ...defaultTokens.radius,
    none: '0',
    sm: '0.25rem',      // 4px
    md: '0.5rem',       // 8px
    lg: '0.75rem',      // 12px
    xl: '1rem',         // 16px
    full: '9999px',
  },
  shadow: {
    ...defaultTokens.shadow,
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },
  transition: {
    ...defaultTokens.transition,
    fast: '150ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
};
